export default __webpack_public_path__ + "static/media/logo1.570657e9.png";